import React from 'react'
import PropTypes from 'prop-types'
import { GenericContentContainer } from './styles'
import ContactPageLayout from 'components/PagesLayout/ContactPageLayout'

const GenericContent = ({ query }) => {
  return (
    <GenericContentContainer>
      <ContactPageLayout query={query} />
    </GenericContentContainer>
  )
}

GenericContent.propTypes = {
  query: PropTypes.object.isRequired,
}

export default GenericContent
